import { createNodeId } from './node-id';
import { isReactiveAccessor } from '../state/accessor';
export function createTextNode(value) {
    return {
        id: createNodeId(),
        type: 'Text',
        props: {},
        children: [],
        text: String(value),
    };
}
export function createReactiveTextNode(value) {
    return {
        id: createNodeId(),
        type: 'TextNode',
        props: { value },
        children: [],
    };
}
export function isUINode(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'type' in value &&
        'props' in value &&
        'children' in value);
}
export function ensureNodeId(node) {
    if (node.id) {
        return node;
    }
    return { ...node, id: createNodeId() };
}
export function isSignalLike(value) {
    return isReactiveAccessor(value);
}
export function normalizeChildNodes(children, options = {}) {
    if (children === null || children === undefined || typeof children === 'boolean') {
        return [];
    }
    if (Array.isArray(children)) {
        return children.flatMap((child) => normalizeChildNodes(child, options));
    }
    if (isSignalLike(children)) {
        return [createReactiveTextNode(children)];
    }
    if (typeof children === 'function') {
        if (options.treatFunctionsAsReactiveText) {
            return [createReactiveTextNode(children)];
        }
        return normalizeChildNodes(children(), options);
    }
    if (isUINode(children)) {
        return [ensureNodeId(children)];
    }
    if (typeof children === 'string' || typeof children === 'number') {
        return [createTextNode(children)];
    }
    return [];
}
//# sourceMappingURL=child-nodes.js.map